import React, { Component } from 'react';
import voca from 'voca';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FieldTypes, CURRENT_USER } from 'drapcode-constant';
import { createFieldKey } from '../../../common/utils/builder-url-util';
import { Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { extractRefField } from '../../../common/utils/field-options';
const { createdBy, password, createdAt, updatedAt, isDeleted, reference } = FieldTypes;

export default class RestAPICollectionFieldsModal extends Component {
  collectionAllowedField = (fields, excludeFields = []) => {
    if (!fields || fields.length === 0) {
      return '';
    }
    const defaultExcludedFields = [createdBy.id, isDeleted.id, reference.id, updatedAt.id];
    const fieldsToShow = fields.filter((field) => {
      return ![...defaultExcludedFields, ...excludeFields].includes(field.type);
    });
    const fieldObjArr = [];
    fieldsToShow.forEach((field) => {
      let fieldJson = { title: field.fieldTitle.en, name: field.fieldName };
      fieldObjArr.push(fieldJson);
    });
    return fieldObjArr;
  };

  getFieldName = (name, prefix) => {
    return prefix ? `${prefix}${name}` : name;
  };

  collectionFieldRows = (collection, prefix = '') => {
    const hide = this.props.hide ? this.props.hide : [];
    if (!collection) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>Collection not found.</td>
        </tr>
      );
    }

    if (collection && (!collection.fields || collection.fields.length === 0)) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>No fields.</td>
        </tr>
      );
    }

    const collectionFields =
      prefix === 'current_user.' && !hide.includes('authToken')
        ? [
            ...this.collectionAllowedField(collection.fields, [password.id]),
            { title: 'Authentication Token', name: 'TOKEN' },
          ]
        : this.collectionAllowedField(collection.fields);

    return (
      collection.fields.length > 0 &&
      collectionFields.map((fieldObj) => (
        <tr key={fieldObj.name} className="text-left td-align-middle">
          <td title={fieldObj.title}>{voca.truncate(fieldObj.title, 30)}</td>
          <td title={fieldObj.name}>
            <>
              <CopyToClipboard
                text={createFieldKey(this.getFieldName(fieldObj.name, prefix))}
                onCopy={this.props.copyToClipboard}
                title={'Copy to clipboard'}
                style={{
                  cursor: 'pointer',
                  padding: '4px',
                  verticalAlign: 'middle',
                  margin: 0,
                }}
              >
                <span>
                  {voca.truncate(this.getFieldName(fieldObj.name, prefix), 30)}
                  <i className="webconnect webconnect-files" />
                </span>
              </CopyToClipboard>
              <span className="float-right">
                {this.props.insertTextToEditor && (
                  <>
                    <span
                      style={{
                        cursor: 'pointer',
                        fontSize: '0.75rem',
                        padding: '4px',
                        verticalAlign: 'middle',
                        margin: 0,
                      }}
                      title="Add field"
                      className="btn badge badge-theme"
                      onClick={() =>
                        this.props.insertTextToEditor(
                          createFieldKey(this.getFieldName(fieldObj.name, prefix)),
                        )
                      }
                    >
                      <i className="material-icons">add_box</i>
                    </span>
                  </>
                )}
              </span>
            </>
          </td>
        </tr>
      ))
    );
  };

  collectionRefFieldRows = (collection, prefix = 'RF::') => {
    const { collections } = this.props;
    const showReferenceFieldInRF = this.props.showReferenceFieldInRF || false;
    if (!collection) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>Collection not found.</td>
        </tr>
      );
    }
    const refFields = extractRefField(
      collection.fields,
      collections,
      [],
      true,
      showReferenceFieldInRF,
    );
    if (collection && (!collection.fields || collection.fields.length === 0 || !refFields)) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>No reference fields.</td>
        </tr>
      );
    }
    return (
      collection.fields.length > 0 &&
      refFields.map((fieldObj) => (
        <tr key={fieldObj.fieldName} className="text-left td-align-middle">
          <td title={fieldObj.fieldTitle}>{voca.truncate(fieldObj.fieldTitle, 30)}</td>
          <td title={fieldObj.fieldName}>
            <>
              <CopyToClipboard
                text={createFieldKey(`${prefix}${fieldObj.fieldName}`)}
                onCopy={this.props.copyToClipboard}
                title={'Copy to clipboard'}
                style={{
                  cursor: 'pointer',
                  padding: '4px',
                  verticalAlign: 'middle',
                  margin: 0,
                }}
              >
                <span>
                  {voca.truncate(`${prefix}${fieldObj.fieldName}`, 35)}
                  <i className="webconnect webconnect-files" />
                </span>
              </CopyToClipboard>
              <span className="float-right">
                {this.props.insertTextToEditor && (
                  <>
                    <span
                      style={{
                        cursor: 'pointer',
                        fontSize: '0.75rem',
                        padding: '4px',
                        verticalAlign: 'middle',
                        margin: 0,
                      }}
                      title="Add field"
                      className="btn badge badge-theme"
                      onClick={() =>
                        this.props.insertTextToEditor(
                          createFieldKey(`${prefix}${fieldObj.fieldName}`),
                        )
                      }
                    >
                      <i className="material-icons">add_box</i>
                    </span>
                  </>
                )}
              </span>
            </>
          </td>
        </tr>
      ))
    );
  };

  collectionDerivedFieldRows = (collection, prefix = 'DF::') => {
    if (!collection) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>Collection not found.</td>
        </tr>
      );
    }

    if (collection && (!collection.utilities || collection.utilities.length === 0)) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>No derived fields.</td>
        </tr>
      );
    }
    return (
      collection.utilities.length > 0 &&
      collection.utilities.map((fieldObj) => (
        <tr key={fieldObj.name} className="text-left td-align-middle">
          <td title={fieldObj.name}>{voca.truncate(fieldObj.name, 30)}</td>
          <td title={fieldObj.name}>
            <>
              <CopyToClipboard
                text={createFieldKey(`${prefix}${fieldObj.name}`)}
                onCopy={this.props.copyToClipboard}
                title={'Copy to clipboard'}
                style={{
                  cursor: 'pointer',
                  padding: '4px',
                  verticalAlign: 'middle',
                  margin: 0,
                }}
              >
                <span>
                  {voca.truncate(`${prefix}${fieldObj.name}`, 35)}
                  <i className="webconnect webconnect-files" />
                </span>
              </CopyToClipboard>
              <span className="float-right">
                {this.props.insertTextToEditor && (
                  <>
                    <span
                      style={{
                        cursor: 'pointer',
                        fontSize: '0.75rem',
                        padding: '4px',
                        verticalAlign: 'middle',
                        margin: 0,
                      }}
                      title="Add field"
                      className="btn badge badge-theme"
                      onClick={() =>
                        this.props.insertTextToEditor(createFieldKey(`${prefix}${fieldObj.name}`))
                      }
                    >
                      <i className="material-icons">add_box</i>
                    </span>
                  </>
                )}
              </span>
            </>
          </td>
        </tr>
      ))
    );
  };

  collectionConstantRows = (collection) => {
    if (!collection) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>Collection not found.</td>
        </tr>
      );
    }

    if (collection && (!collection.constants || collection.constants.length === 0)) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>No constants.</td>
        </tr>
      );
    }
    return (
      collection.constants.length > 0 &&
      collection.constants.map((fieldObj) => (
        <tr key={fieldObj.name} className="text-left td-align-middle">
          <td title={fieldObj.name}>{voca.truncate(fieldObj.name, 30)}</td>
          <td title={fieldObj.name}>
            <>
              <CopyToClipboard
                text={createFieldKey(`CC::${fieldObj.name}`)}
                onCopy={this.props.copyToClipboard}
                title={'Copy to clipboard'}
                style={{
                  cursor: 'pointer',
                  padding: '4px',
                  verticalAlign: 'middle',
                  margin: 0,
                }}
              >
                <span>
                  {voca.truncate(`CC::${fieldObj.name}`, 35)}
                  <i className="webconnect webconnect-files" />
                </span>
              </CopyToClipboard>
              <span className="float-right">
                {this.props.insertTextToEditor && (
                  <>
                    <span
                      style={{
                        cursor: 'pointer',
                        fontSize: '0.75rem',
                        padding: '4px',
                        verticalAlign: 'middle',
                        margin: 0,
                      }}
                      title="Add field"
                      className="btn badge badge-theme"
                      onClick={() =>
                        this.props.insertTextToEditor(createFieldKey(`CC::${fieldObj.name}`))
                      }
                    >
                      <i className="material-icons">add_box</i>
                    </span>
                  </>
                )}
              </span>
            </>
          </td>
        </tr>
      ))
    );
  };

  projectConstantRows = (projectDetail) => {
    if (!projectDetail || !projectDetail.constants || projectDetail.constants.length === 0) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>No project constants.</td>
        </tr>
      );
    }
    return (
      projectDetail &&
      projectDetail.constants &&
      projectDetail.constants
        .filter((fieldObj) => fieldObj.name !== CURRENT_USER)
        .map((fieldObj) => (
          <tr key={fieldObj.name} className="text-left td-align-middle">
            <td title={fieldObj.name}>{voca.truncate(fieldObj.name, 30)}</td>
            <td title={fieldObj.name}>
              <>
                <CopyToClipboard
                  text={createFieldKey(`PC::${fieldObj.name}`)}
                  onCopy={this.props.copyToClipboard}
                  title={'Copy to clipboard'}
                  style={{
                    cursor: 'pointer',
                    padding: '4px',
                    verticalAlign: 'middle',
                    margin: 0,
                  }}
                >
                  <span>
                    {voca.truncate(`PC::${fieldObj.name}`, 35)}
                    <i className="webconnect webconnect-files" />
                  </span>
                </CopyToClipboard>
                <span className="float-right">
                  {this.props.insertTextToEditor && (
                    <>
                      <span
                        style={{
                          cursor: 'pointer',
                          fontSize: '0.75rem',
                          padding: '4px',
                          verticalAlign: 'middle',
                          margin: 0,
                        }}
                        title="Add field"
                        className="btn badge badge-theme"
                        onClick={() =>
                          this.props.insertTextToEditor(createFieldKey(`PC::${fieldObj.name}`))
                        }
                      >
                        <i className="material-icons">add_box</i>
                      </span>
                    </>
                  )}
                </span>
              </>
            </td>
          </tr>
        ))
    );
  };

  projectEnvironmentRows = (projectDetail) => {
    if (!projectDetail || !projectDetail.environments || projectDetail.environments.length === 0) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>No project environments.</td>
        </tr>
      );
    }
    const { environments } = projectDetail;
    const envConstants = environments.map(
      (env) =>
        env.constants &&
        env.constants.map((envConstant) => {
          return {
            envName: env.name,
            envType: env.envType,
            name: envConstant.name,
          };
        }),
    )[0];

    if (!envConstants || envConstants.length === 0) {
      return (
        <tr className="text-left td-align-middle">
          <td colSpan={2}>No project environment constants.</td>
        </tr>
      );
    }

    return (
      projectDetail &&
      envConstants &&
      envConstants.map((fieldObj, index) => (
        <tr key={index} className="text-left td-align-middle">
          {/* <td title={fieldObj.envName}>{voca.truncate(fieldObj.envName, 30)}</td> */}
          {/* <td title={fieldObj.envType}>{voca.truncate(fieldObj.envType, 30)}</td> */}
          <td title={fieldObj.name}>
            <>
              <CopyToClipboard
                text={createFieldKey(`environment_variable.${fieldObj.name}`)}
                onCopy={this.props.copyToClipboard}
                title={'Copy to clipboard'}
                style={{
                  cursor: 'pointer',
                  padding: '4px',
                  verticalAlign: 'middle',
                  margin: 0,
                }}
              >
                <span>
                  {voca.truncate(`${fieldObj.name}`, 35)}
                  <i className="webconnect webconnect-files" />
                </span>
              </CopyToClipboard>
              <span className="float-right">
                {this.props.insertTextToEditor && (
                  <>
                    <span
                      style={{
                        cursor: 'pointer',
                        fontSize: '0.75rem',
                        padding: '4px',
                        verticalAlign: 'middle',
                        margin: 0,
                      }}
                      title="Add field"
                      className="btn badge badge-theme"
                      onClick={() =>
                        this.props.insertTextToEditor(
                          createFieldKey(`environment_variable.${fieldObj.name}`),
                        )
                      }
                    >
                      <i className="material-icons">add_box</i>
                    </span>
                  </>
                )}
              </span>
            </>
          </td>
        </tr>
      ))
    );
  };

  sessionRow = () => {
    return (
      <>
        <tr key={'Browser Session Storage'} className="text-left td-align-middle">
          <td title={'Browser Session Storage'}>{voca.truncate('Browser Session Storage', 30)}</td>
          <td title={'Browser Session Storage'}>
            <>
              <CopyToClipboard
                text={createFieldKey(`SESSION_STORAGE.<replace_with_key_full_path>`)}
                onCopy={this.props.copyToClipboard}
                title={'Copy to clipboard'}
                style={{
                  cursor: 'pointer',
                  padding: '4px',
                  verticalAlign: 'middle',
                  margin: 0,
                }}
              >
                <span>
                  {voca.truncate(`${'SESSION_STORAGE.<replace_with_key_full_path>'}`, 35)}
                  <i className="webconnect webconnect-files" />
                </span>
              </CopyToClipboard>
              <span className="float-right">
                {this.props.insertTextToEditor && (
                  <>
                    <span
                      style={{
                        cursor: 'pointer',
                        fontSize: '0.75rem',
                        padding: '4px',
                        verticalAlign: 'middle',
                        margin: 0,
                      }}
                      title="Add field"
                      className="btn badge badge-theme"
                      onClick={() =>
                        this.props.insertTextToEditor(
                          createFieldKey(`SESSION_STORAGE.<replace_with_key_full_path>`),
                        )
                      }
                    >
                      <i className="material-icons">add_box</i>
                    </span>
                  </>
                )}
              </span>
            </>
          </td>
        </tr>
        <tr key={'Browser Local Storage'} className="text-left td-align-middle">
          <td title={'Browser Local Storage'}>{voca.truncate('Browser Local Storage', 30)}</td>
          <td title={'Browser Local Storage'}>
            <>
              <CopyToClipboard
                text={createFieldKey(`LOCAL_STORAGE.<replace_with_key_full_path>`)}
                onCopy={this.props.copyToClipboard}
                title={'Copy to clipboard'}
                style={{
                  cursor: 'pointer',
                  padding: '4px',
                  verticalAlign: 'middle',
                  margin: 0,
                }}
              >
                <span>
                  {voca.truncate(`${'LOCAL_STORAGE.<replace_with_key_full_path>'}`, 35)}
                  <i className="webconnect webconnect-files" />
                </span>
              </CopyToClipboard>
              <span className="float-right">
                {this.props.insertTextToEditor && (
                  <>
                    <span
                      style={{
                        cursor: 'pointer',
                        fontSize: '0.75rem',
                        padding: '4px',
                        verticalAlign: 'middle',
                        margin: 0,
                      }}
                      title="Add field"
                      className="btn badge badge-theme"
                      onClick={() =>
                        this.props.insertTextToEditor(
                          createFieldKey(`LOCAL_STORAGE.<replace_with_key_full_path>`),
                        )
                      }
                    >
                      <i className="material-icons">add_box</i>
                    </span>
                  </>
                )}
              </span>
            </>
          </td>
        </tr>
        <tr key={'Browser Cookies'} className="text-left td-align-middle">
          <td title={'Browser Cookies'}>{voca.truncate('Browser Cookies', 30)}</td>
          <td title={'Browser Cookies'}>
            <>
              <CopyToClipboard
                text={createFieldKey(`COOKIES.<replace_with_key_full_path>`)}
                onCopy={this.props.copyToClipboard}
                title={'Copy to clipboard'}
                style={{
                  cursor: 'pointer',
                  padding: '4px',
                  verticalAlign: 'middle',
                  margin: 0,
                }}
              >
                <span>
                  {voca.truncate(`${'COOKIES.<replace_with_key_full_path>'}`, 35)}
                  <i className="webconnect webconnect-files" />
                </span>
              </CopyToClipboard>
              <span className="float-right">
                {this.props.insertTextToEditor && (
                  <>
                    <span
                      style={{
                        cursor: 'pointer',
                        fontSize: '0.75rem',
                        padding: '4px',
                        verticalAlign: 'middle',
                        margin: 0,
                      }}
                      title="Add field"
                      className="btn badge badge-theme"
                      onClick={() =>
                        this.props.insertTextToEditor(
                          createFieldKey(`COOKIES.<replace_with_key_full_path>`),
                        )
                      }
                    >
                      <i className="material-icons">add_box</i>
                    </span>
                  </>
                )}
              </span>
            </>
          </td>
        </tr>
        <tr key={'Browser IndexedDB'} className="text-left td-align-middle">
          <td title={'Browser IndexedDB'}>{voca.truncate('Browser IndexedDB', 30)}</td>
          <td title={'Browser IndexedDB'}>
            <>
              <CopyToClipboard
                text={createFieldKey(`INDEXED_DB.<replace_with_key_full_path>`)}
                onCopy={this.props.copyToClipboard}
                title={'Copy to clipboard'}
                style={{
                  cursor: 'pointer',
                  padding: '4px',
                  verticalAlign: 'middle',
                  margin: 0,
                }}
              >
                <span>
                  {voca.truncate(`${'INDEXED_DB.<replace_with_key_full_path>'}`, 35)}
                  <i className="webconnect webconnect-files" />
                </span>
              </CopyToClipboard>
              <span className="float-right">
                {this.props.insertTextToEditor && (
                  <>
                    <span
                      style={{
                        cursor: 'pointer',
                        fontSize: '0.75rem',
                        padding: '4px',
                        verticalAlign: 'middle',
                        margin: 0,
                      }}
                      title="Add field"
                      className="btn badge badge-theme"
                      onClick={() =>
                        this.props.insertTextToEditor(
                          createFieldKey(`INDEXED_DB.<replace_with_key_full_path>`),
                        )
                      }
                    >
                      <i className="material-icons">add_box</i>
                    </span>
                  </>
                )}
              </span>
            </>
          </td>
        </tr>
      </>
    );
  };

  render() {
    const {
      selectedCollection,
      projectDetail,
      collections,
      bodyDataFrom,
      tenantCollectionId,
      userSettingCollectionId,
      subTenantCollectionId,
    } = this.props;
    const hide = this.props.hide ? this.props.hide : [];
    const userCollection =
      collections && collections.find((collection) => collection.collectionName === 'user');
    const multiTenantCollection =
      collections && collections.find((collection) => collection.uuid === tenantCollectionId);
    const userSettingCollection =
      collections && collections.find((collection) => collection.uuid === userSettingCollectionId);
    const subTenantCollection =
      collections && collections.find((collection) => collection.uuid === subTenantCollectionId);
    const notForCollectionFields = ['noDynamicData', 'formData', 'RAW_JSON'];
    return (
      <>
        <Modal
          isOpen={this.props.toggleFields}
          toggle={this.props.toggleFieldsModal}
          backdrop="static"
          style={{ maxWidth: '800px', marginTop: '70px' }}
        >
          <ModalHeader toggle={this.props.toggleFieldsModal} className="border-bottom">
            <strong>Fields</strong>
          </ModalHeader>
          <ModalBody>
            <Accordion
              allowZeroExpanded
              preExpanded={[
                bodyDataFrom && notForCollectionFields.includes(bodyDataFrom)
                  ? 'user-fields'
                  : 'fields',
              ]}
            >
              {!notForCollectionFields.includes(bodyDataFrom) && (
                <>
                  {!hide.includes('fields') && (
                    <AccordionItem key={'fields'} uuid={'fields'}>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <i className={`wb webconnect-card-list`}></i>{' '}
                          <strong>
                            {selectedCollection
                              ? voca.truncate(selectedCollection.collectionTitle, 30)
                              : 'Collection'}{' '}
                            Fields
                          </strong>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <div className="table-responsive">
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th>Title</th>
                                <th>Name</th>
                              </tr>
                            </thead>
                            <tbody>{this.collectionFieldRows(selectedCollection)}</tbody>
                          </table>
                        </div>
                      </AccordionItemPanel>
                    </AccordionItem>
                  )}
                  {!hide.includes('refFields') && (
                    <AccordionItem key={'ref-fields'} uuid={'ref-fields'}>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <i className={`wb webconnect-inboxes`}></i>{' '}
                          <strong>
                            {selectedCollection
                              ? voca.truncate(selectedCollection.collectionTitle, 30)
                              : 'Collection'}{' '}
                            Reference Fields
                          </strong>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <div className="table-responsive">
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th>Title</th>
                                <th>Name</th>
                              </tr>
                            </thead>
                            <tbody>{this.collectionRefFieldRows(selectedCollection)}</tbody>
                          </table>
                        </div>
                      </AccordionItemPanel>
                    </AccordionItem>
                  )}
                  {!hide.includes('derivedFields') && (
                    <AccordionItem key={'derived-fields'} uuid={'derived-fields'}>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <i className={`wb webconnect-box-arrow-in-right`}></i>{' '}
                          <strong>
                            {selectedCollection
                              ? voca.truncate(selectedCollection.collectionTitle, 30)
                              : 'Collection'}{' '}
                            Derived Fields
                          </strong>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <div className="table-responsive">
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th>Title</th>
                                <th>Name</th>
                              </tr>
                            </thead>
                            <tbody>{this.collectionDerivedFieldRows(selectedCollection)}</tbody>
                          </table>
                        </div>
                      </AccordionItemPanel>
                    </AccordionItem>
                  )}
                </>
              )}
              {!hide.includes('userFields') && (
                <AccordionItem key={'user-fields'} uuid={'user-fields'}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <i className={`wb webconnect-card-list`}></i>{' '}
                      <strong>{'Current LoggedIn User Fields'}</strong>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="table-responsive">
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th>User Fields</th>
                            <th>Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.collectionFieldRows(userCollection, 'current_user.')}
                          {this.collectionRefFieldRows(userCollection, 'current_user.')}
                        </tbody>
                      </table>
                    </div>
                    {!hide.includes('userDerivedFields') && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead>
                            <tr>
                              <th>Derived Field</th>
                              <th>Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.collectionDerivedFieldRows(userCollection, 'current_user.DF::')}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </AccordionItemPanel>
                </AccordionItem>
              )}
              {!hide.includes('tenantFields') && (
                <AccordionItem key={'tenant-fields'} uuid={'tenant-fields'}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <i className={`wb webconnect-card-list`}></i>{' '}
                      <strong>{'Current LoggedIn Tenant Fields'}</strong>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="table-responsive">
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th>Tenant Fields</th>
                            <th>Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.collectionFieldRows(multiTenantCollection, 'current_tenant.')}
                          {this.collectionRefFieldRows(multiTenantCollection, 'current_tenant.')}
                        </tbody>
                      </table>
                    </div>
                    {!hide.includes('tenantDerivedFields') && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead>
                            <tr>
                              <th>Derived Field</th>
                              <th>Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.collectionDerivedFieldRows(
                              multiTenantCollection,
                              'current_tenant.DF::',
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </AccordionItemPanel>
                </AccordionItem>
              )}
              {!hide.includes('userSettingFields') && (
                <AccordionItem key={'user-setting-fields'} uuid={'user-setting-fields'}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <i className={`wb webconnect-card-list`}></i>{' '}
                      <strong>{'Current LoggedIn User Settings Fields'}</strong>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="table-responsive">
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th>User Setting Fields</th>
                            <th>Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.collectionFieldRows(userSettingCollection, 'current_settings.')}
                          {this.collectionRefFieldRows(userSettingCollection, 'current_settings.')}
                        </tbody>
                      </table>
                    </div>
                    {!hide.includes('userSettingDerivedFields') && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead>
                            <tr>
                              <th>Derived Field</th>
                              <th>Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.collectionDerivedFieldRows(
                              userSettingCollection,
                              'current_settings.DF::',
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </AccordionItemPanel>
                </AccordionItem>
              )}
              {!hide.includes('subTenantFields') && (
                <AccordionItem key={'sub-tenant-fields'} uuid={'sub-tenant-fields'}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <i className={`wb webconnect-card-list`}></i>{' '}
                      <strong>{'Current LoggedIn Sub Tenant Fields'}</strong>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="table-responsive">
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th>Sub Tenant Fields</th>
                            <th>Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.collectionFieldRows(subTenantCollection, 'current_sub_tenant.')}
                          {this.collectionRefFieldRows(subTenantCollection, 'current_sub_tenant.')}
                        </tbody>
                      </table>
                    </div>
                    {!hide.includes('subTenantDerivedFields') && (
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead>
                            <tr>
                              <th>Derived Field</th>
                              <th>Name</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.collectionDerivedFieldRows(
                              subTenantCollection,
                              'current_sub_tenant.DF::',
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </AccordionItemPanel>
                </AccordionItem>
              )}
              {!hide.includes('currentSession') && (
                <AccordionItem key={'current-session'} uuid={'current-session'}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <i className={`wb webconnect-form`}></i> <strong>{'Browser Storage'}</strong>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="table-responsive">
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th>Name</th>
                          </tr>
                        </thead>
                        <tbody>{this.sessionRow()}</tbody>
                      </table>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              )}
              {!hide.includes('environmentVariable') && (
                <AccordionItem key={'environment_variable'} uuid={'environment_variable'}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <i className={`wb webconnect-form`}></i>{' '}
                      <strong>{'Environment Variables'}</strong>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="table-responsive">
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            {/* <th>Name</th>
                            <th>Type</th> */}
                            <th>Name</th>
                          </tr>
                        </thead>
                        <tbody>{this.projectEnvironmentRows(projectDetail)}</tbody>
                      </table>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              )}
              {!notForCollectionFields.includes(bodyDataFrom) && (
                <>
                  {!hide.includes('collectionConstants') && (
                    <AccordionItem key={'collection-constants'} uuid={'collection-constants'}>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <i className={`wb webconnect-vector-pen`}></i>{' '}
                          <strong>
                            {selectedCollection
                              ? voca.truncate(selectedCollection.collectionTitle, 30)
                              : 'Collection'}{' '}
                            Constants
                          </strong>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <div className="table-responsive">
                          <table className="table table-bordered table-sm">
                            <thead>
                              <tr>
                                <th>Title</th>
                                <th>Name</th>
                              </tr>
                            </thead>
                            <tbody>{this.collectionConstantRows(selectedCollection)}</tbody>
                          </table>
                        </div>
                      </AccordionItemPanel>
                    </AccordionItem>
                  )}
                </>
              )}
              {!hide.includes('projectConstants') && (
                <AccordionItem key={'project-constants'} uuid={'project-constants'}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <i className={`wb webconnect-form`}></i>{' '}
                      <strong>{'Project Constants'}</strong>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <div className="table-responsive">
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th>Name</th>
                          </tr>
                        </thead>
                        <tbody>{this.projectConstantRows(projectDetail)}</tbody>
                      </table>
                    </div>
                  </AccordionItemPanel>
                </AccordionItem>
              )}
            </Accordion>
          </ModalBody>
        </Modal>
      </>
    );
  }
}
